























































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import numeral from 'numeral';

interface IData {
  familyName: string,
  isSubFamily?: boolean,
  total: number,
  isTotal?: boolean,
}

@Component({
  name: 'TableMethodologicalInfo'
})
export default class TableMethodologicalInfoComponent extends Vue {
  public numeral = numeral;

  @Prop({ required: true })
  public show: boolean;

  private toggleInfoModal() {
    this.$emit('toggleModal');
  }

  public get sourceData(): IData[] {
    return [
      {
        familyName: 'Ranger',
        total: 0.345,
      },
      {
        familyName: 'Ranger L',
        total: 0.594,
      },
      {
        familyName: 'Ranger L - CD',
        total: 0.594,
        isSubFamily: true,
      },
      {
        familyName: 'Ranger L - CS',
        total: 0.0,
        isSubFamily: true,
      },
      {
        familyName: 'Ranger L - CH',
        total: 0.0,
        isSubFamily: true,
      },
      {
        familyName: 'Ranger M',
        total: 0.353,
      },
      {
        familyName: 'Ranger H',
        total: 0.349,
      },
      {
        familyName: 'Transit Van',
        total: 0.063,
      },
      {
        familyName: 'Transit Bus',
        total: 0.154,
      },
      {
        familyName: 'Transit Chassi',
        total: 0.029,
      },
    ]
  }
}
